<template>
    <div class="w-full bg-white px-6 flex items-center justify-between rounded-lg shadow widget-card px-4">
        <div class="w-full flex flex-col items-center">
            <slot name="title">
                <h5
                    v-if="caption"
                    class="text-main-2xl font-semibold mx-3"
                >
                    {{ caption }}
                </h5>
            </slot>
            <slot name="content">
                <h2
                    v-if="cardValue"
                    class="text-6xl font-semibold mx-3 text-green"
                >
                    0
                </h2>
            </slot>
        </div>
        <div
            v-if="editable"
            class="flex editable-content"
        >
            <VcPopover
                class="item"
                trigger="hover"
                placement="top"
            >
                <template #reference>
                    <TrashIcon
                        class="flex align-center w-8 h-8 p-2 text-red trash-icon"
                        @click="emit('remove-item')"
                    />
                </template>
                {{ t('tooltip.remove.widget') }}
            </VcPopover>
            <VcPopover
                class="item"
                trigger="hover"
                placement="top"
            >
                <template #reference>
                    <EditIcon class="flex align-center w-10 h-8 p-2 edit-icon text-primary" />
                </template>
                {{ t('tooltip.edit.widget') }}
            </VcPopover>
            <MoreVerticalIcon class="flex align-center w-5 h-8 text-primary -mx-1" />
            <MoreVerticalIcon class="flex align-center w-5 h-8 text-primary -mx-2" />
        </div>
        <div v-else>
            <VcPopover
                class="item"
                trigger="hover"
                placement="top"
            >
                <template #reference>
                    <EditIcon
                        class="flex align-center w-10 h-8 p-2 edit-card-icon text-primary"
                    />
                </template>
                {{ t('tooltip.edit.widget') }}
            </VcPopover>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VcPopover } from '@voicenter-team/voicenter-ui-plus'
import { Trash as TrashIcon, Pencil as EditIcon, MoreVertical as MoreVerticalIcon } from 'lucide-vue-next'

const { t } = useI18n()

withDefaults(
    defineProps<{
        caption?: string | number
        cardValue?: string | number
        editable?: boolean
    }>(),
    {
        caption: '- -',
        cardValue: '- -',
        editable: true
    }
)

const emit = defineEmits<{
    (e: 'remove-item'): void
}>()
</script>
